import { useCallback, useContext, useMemo, useState } from "react";
import { EventosPg } from "../../../../types";
import api from "../../../../utils/api";


interface GetMembrosProps {

}

export type ResponseMembrosCheckin = {
  listAll: EventosPg[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: EventosPg[]
  pagina: number
  getSearchPerMiniter: (event: any) => void ,
  pesquisaPorMinisterio: string
}

const GetEventsCheckin = () => {

  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');
  const [listCheckinMembros, setListCheckinMembros] = useState<EventosPg[]>([]);
  const [list, setList] = useState<EventosPg[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);


  const getSearchPerMiniter = (event: any) => setPesquisaPorMinisterio(event?.target?.value);

  const reset = async () => {
    await getList()
  }

  const getWithParams = (params: any) => {
    api.get<EventosPg[]>('evento/geral/grupo/8', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<EventosPg[]>('evento/geral/grupo/8')
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, []);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listCheckinMembros,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams,
    pesquisaPorMinisterio,
    getSearchPerMiniter
  };
}

export default GetEventsCheckin;
